module.exports = __webpack_public_path__ + "a04a22759bcb1e31098cef4199a4e1f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fam/adirondack_funds.png
// module id = 1606
// module chunks = 0